module.exports = __webpack_public_path__ + "img/2.10dba3a8.png";